import getWallet from "./wallet";
import getContract from "./contract";
import axios from "axios";
import { proxyContract, getContractCreationBlock } from "./contract";
import getProvider from "./rpcProviderService";
import { ethers } from "ethers";
import levelPrices from './levelPrice'

const blockLimit = 1000;
export const getActivities = async (userId, limit) => {
  const contract = await getContract();
  const provider = await getProvider(true);
  
  const filter = contract.filters.DirectPaid(userId);

  const latestBlock = await provider.getBlockNumber();
  let startBlock = await getContractCreationBlock();

  let reverseStartBlock = latestBlock - blockLimit;
  let reverseEndBlock = latestBlock;

  if(reverseStartBlock < startBlock)
    reverseStartBlock = startBlock;

  let totalEvents = [];
  let doBreak = false;

  while(reverseStartBlock >= startBlock) {
    const events = await contract.queryFilter(filter, reverseStartBlock, reverseEndBlock);

    if(reverseStartBlock <= startBlock) {
      doBreak = true;
      reverseEndBlock = reverseStartBlock;
      reverseStartBlock = startBlock;
    } else {
      reverseEndBlock = reverseStartBlock;
      reverseStartBlock = reverseStartBlock - blockLimit;
    }
    
    console.log("From: ", reverseStartBlock, "To: ", reverseEndBlock, "Events: ", events);
    if(events.length > 0) {
      totalEvents = totalEvents.concat(...events)
    }

    if(doBreak || totalEvents.length >= limit) break;
  }
  return totalEvents;
};

export const getDirectPayouts = async (toId, level, limit) => {
  const contract = await getContract();
  const provider = await getProvider(true);
  
  const filter = contract.filters.DirectPaid(toId);

  const latestBlock = await provider.getBlockNumber();
  let startBlock = await getContractCreationBlock();

  let reverseStartBlock = latestBlock - blockLimit;
  let reverseEndBlock = latestBlock;

  if(reverseStartBlock < startBlock)
    reverseStartBlock = startBlock;

  let totalEvents = [];
  let doBreak = false;

  while(reverseStartBlock >= startBlock) {
    if(reverseStartBlock <= startBlock) {
      doBreak = true;
      reverseStartBlock = startBlock;
    }

    const events = await contract.queryFilter(filter, reverseStartBlock, reverseEndBlock);

    reverseEndBlock = reverseStartBlock;
    reverseStartBlock = reverseStartBlock - blockLimit;

    // console.log("From: ", reverseStartBlock, "To: ", reverseEndBlock, "Events: ", events);
    if(events.length > 0) {
      let eventData = [];
      events.forEach((event) => {
        let data = {};
        const lvl = ethers.BigNumber.from(event.args["level"]).toNumber();
        if(lvl == level) {
          const date = getDate(ethers.BigNumber.from(event.args[4]).toNumber());
          data.time = date.toDateString();
          data.isDirectIncome = true;
          data.amount = ethers.utils.formatEther(event.args[2]);
          data.senderId = ethers.BigNumber.from(event.args[1]).toNumber();
          eventData.push(data);
        }
      });

      totalEvents = totalEvents.concat(eventData)
    }

    if(doBreak || totalEvents.length >= limit) break;
  }
  return totalEvents;
};

export const getTreePayouts = async (receiverId, level, limit) => {
  const contract = await getContract();
  const provider = await getProvider(true);
  
  const filter = contract.filters.TreePayout(receiverId);

  const latestBlock = await provider.getBlockNumber();
  let startBlock = await getContractCreationBlock();

  let reverseStartBlock = latestBlock - blockLimit;
  let reverseEndBlock = latestBlock;

  if(reverseStartBlock < startBlock)
    reverseStartBlock = startBlock;

  let totalEvents = [];
  let doBreak = false;

  while(reverseStartBlock >= startBlock) {
    if(reverseStartBlock <= startBlock) {
      doBreak = true;
      reverseStartBlock = startBlock;
    }

    const events = await contract.queryFilter(filter, reverseStartBlock, reverseEndBlock);

    reverseEndBlock = reverseStartBlock;
    reverseStartBlock = reverseStartBlock - blockLimit;
    
    // console.log("From: ", reverseStartBlock, "To: ", reverseEndBlock, "Events: ", events);
    if(events.length > 0) {
      let eventData = [];
      events.forEach((event) => {
        let data = {};
        const lvl = ethers.BigNumber.from(event.args["level"]).toNumber();
        if(lvl == level) {
          const date = getDate(ethers.BigNumber.from(event.args[5]).toNumber());
          data.time = date.toDateString();
          data.isDirectIncome = false;
          data.amount = ethers.utils.formatEther(event.args[5])
          data.senderId = ethers.BigNumber.from(event.args[1]).toNumber();
          eventData.push(data);
        }
      });
      

      totalEvents = totalEvents.concat(eventData)
    }

    if(doBreak || totalEvents.length >= limit) break;
  }
  return totalEvents;
};

export const getRegistrationActivities = async (limit) => {
  const contract = await getContract();
  const provider = await getProvider(true);
  
  const filter = contract.filters.Registration();
  
  
  const latestBlock = await provider.getBlockNumber();
  let startBlock = await getContractCreationBlock();
  console.log("startBlock: ", startBlock);

  let reverseStartBlock = latestBlock - blockLimit;
  let reverseEndBlock = latestBlock;

  if(reverseStartBlock < startBlock)
    reverseStartBlock = startBlock;

  let totalEvents = [];
  let doBreak = false;

  while(reverseStartBlock >= startBlock) {
    if(reverseStartBlock <= startBlock) {
      doBreak = true;
      reverseStartBlock = startBlock;
    }

    const events = await contract.queryFilter(filter, reverseStartBlock, reverseEndBlock);

    reverseEndBlock = reverseStartBlock;
    reverseStartBlock = reverseStartBlock - blockLimit;

    // console.log("From: ", reverseStartBlock, "To: ", reverseEndBlock, "Events: ", events);
    if(events.length > 0) {
      let eventData = [];
      events.forEach((event) => {
        let data = {};
        data.isRegistrationEvent = true;
        data.id = ethers.BigNumber.from(event.args[0]).toNumber();
        data.txId = event.transactionHash;
        data.amount = levelPrices[0];
        const date = getDate(ethers.BigNumber.from(event.args[3]).toNumber());
        data.time = date;
        eventData.push(data);
      });

      totalEvents = totalEvents.concat(eventData);
    }

    if(doBreak || totalEvents.length >= limit) break;
  }
  return totalEvents;
};

export const getUpgradeActivities = async (limit) => {
  const contract = await getContract();
  const provider = await getProvider(true);
  
  const filter = contract.filters.Upgrade();
  
  
  const latestBlock = await provider.getBlockNumber();
  let startBlock = await getContractCreationBlock();
  console.log("startBlock: ", startBlock);

  let reverseStartBlock = latestBlock - blockLimit;
  let reverseEndBlock = latestBlock;

  if(reverseStartBlock < startBlock)
    reverseStartBlock = startBlock;

  let totalEvents = [];
  let doBreak = false;

  while(reverseStartBlock >= startBlock) {
    if(reverseStartBlock <= startBlock) {
      doBreak = true;
      reverseStartBlock = startBlock;
    }

    const events = await contract.queryFilter(filter, reverseStartBlock, reverseEndBlock);

    reverseEndBlock = reverseStartBlock;
    reverseStartBlock = reverseStartBlock - blockLimit;

    // console.log("From: ", reverseStartBlock, "To: ", reverseEndBlock, "Events: ", events);
    if(events.length > 0) {
      let eventData = [];
      events.forEach((event) => {
        let data = {};
        data.isRegistrationEvent = false;
        data.id = ethers.BigNumber.from(event.args[0]).toNumber();
        data.txId = event.transactionHash;
        data.amount = levelPrices[ethers.BigNumber.from(event.args[3]).toNumber() - 1];
        const date = getDate(ethers.BigNumber.from(event.args[4]).toNumber());
        data.time = date;
        eventData.push(data);
      });

      totalEvents = totalEvents.concat(eventData);
    }

    if(doBreak || totalEvents.length >= limit) break;
  }
  return totalEvents;
};

export const getLastActivities = async (limit) => {
  
  const registrationEvents = await getRegistrationActivities(limit);
  console.log(registrationEvents);
  const upgradeEvents = await getUpgradeActivities(limit);
  console.log(upgradeEvents);
  let data = registrationEvents.concat(upgradeEvents);
  data.sort(function(a, b) {
    let dateA = new Date(a.time);
    let dateB = new Date(b.time);
    return dateB - dateA;
  });
  console.log(data);
  return data;
  // const registrationEvents = await getRegistrationActivities(limit);
  // let data = {};
  // if (registerEvent) {
  //   const result = registerEvent.result;
  //   data.isRegistrationEvent = true;
  //   data.txId = transactions[i].txID;
  //   data.id = result.newUserId;
  //   const date = getDate(result.time);
  //   data.time = date.toDateString();
  //   activities.push(data);
  // }

  // data = {};
  // if (treePayoutEvent) {
  //   const result = treePayoutEvent.result;
  //   data.isRegistrationEvent = false;
  //   data.id = result.receiverId;
  //   data.txId = transactions[i].txID;
  //   data.amount = result.amount;
  //   const date = getDate(result.time);
  //   data.time = date.toDateString();
  //   activities.push(data);
  // }
};

export const getPayoutActivities = async (userId, level, limit) => {
  const directPayoutEvents = await getDirectPayouts(userId, level, limit);
  const treePayoutEvents = await getTreePayouts(userId, level, limit);
  
  let activites = directPayoutEvents.concat(treePayoutEvents);
  activites.sort((a, b) => new Date(a.time) - new Date(b.time));
  return activites;
};

export const getPartnersActivities = async (refId, limit) => {
  const contract = await getContract();
  const provider = await getProvider(true);
  
  const filter = contract.filters.Registration(null, refId);

  const latestBlock = await provider.getBlockNumber();
  let startBlock = await getContractCreationBlock();
  
  let reverseStartBlock = latestBlock - blockLimit;
  let reverseEndBlock = latestBlock;

  if(reverseStartBlock < startBlock)
    reverseStartBlock = startBlock;

  let totalEvents = [];
  let doBreak = false;

  while(reverseStartBlock >= startBlock) {
    if(reverseStartBlock <= startBlock) {
      doBreak = true;
      reverseStartBlock = startBlock;
    }

    const events = await contract.queryFilter(filter, reverseStartBlock, reverseEndBlock);

    reverseEndBlock = reverseStartBlock;
    reverseStartBlock = reverseStartBlock - blockLimit;

    console.log("From: ", reverseStartBlock, "To: ", reverseEndBlock, "Events: ", events);
    if(events.length > 0) {
      let eventData = [];
      for(let i=0; i<events.length; i++) {
        const userAddress = await contract.getAddressById(ethers.BigNumber.from(events[i].args[0]).toNumber());
        const userInfo = await contract.userInfos(userAddress);
        let data = {};
        data.isRegistrationEvent = true;
        data.userId = ethers.BigNumber.from(events[i].args[0]).toNumber();
        data.txId = events[i].transactionHash;
        data.address = userAddress;
        const partnerIncome = userInfo["totalIncome"];

        if(partnerIncome.gt(ethers.BigNumber.from(0))) data["partnerIncome"] = ethers.utils.formatEther(partnerIncome);
        else data["partnerIncome"] = 0;

        const date = getDate(ethers.BigNumber.from(events[i].args[3]).toNumber());
        data.joinDate = date.toDateString();
        eventData.push(data);
      }
      events.forEach((event) => {
        
      });

      totalEvents = totalEvents.concat(eventData);
    }

    if(doBreak || totalEvents.length >= limit) break;
  }
  return totalEvents;
};

export const getStatsData = async (toId, limit) => {
  const contract = await getContract();
  const provider = await getProvider(true);
  
  const filter = contract.filters.DirectPaid(toId);

  const latestBlock = await provider.getBlockNumber();
  let startBlock = await getContractCreationBlock();

  let reverseStartBlock = latestBlock - blockLimit;
  let reverseEndBlock = latestBlock;

  if(reverseStartBlock < startBlock)
    reverseStartBlock = startBlock;

  let totalEvents = [];
  let doBreak = false;

  while(reverseStartBlock >= startBlock) {
    if(reverseStartBlock <= startBlock) {
      doBreak = true;
      reverseStartBlock = startBlock;
    }

    const events = await contract.queryFilter(filter, reverseStartBlock, reverseEndBlock);

    reverseEndBlock = reverseStartBlock;
    reverseStartBlock = reverseStartBlock - blockLimit;

    // console.log("From: ", reverseStartBlock, "To: ", reverseEndBlock, "Events: ", events);
    if(events.length > 0) {
      let eventData = [];
      events.forEach((event) => {
          let data = {};
          const date = getDate(ethers.BigNumber.from(event.args[4]).toNumber());
          data.joinDate = date.toDateString();
          data.isDirectIncome = true;
          data.amount = ethers.utils.formatEther(event.args[2]);
          data.from = ethers.BigNumber.from(event.args[1]).toNumber();
          data.to = ethers.BigNumber.from(event.args["to"]).toNumber();
          data.level = ethers.BigNumber.from(event.args["level"]).toNumber();
          eventData.push(data);
      });

      totalEvents = totalEvents.concat(eventData)
    }

    if(doBreak || totalEvents.length >= limit) break;
  }
  return totalEvents;
};

// export const getPartnersActivities = async (userId) => {
//   const tronWeb = await getWallet();
//   if (tronWeb && tronWeb.defaultAddress != false) {
//     const response = await tronWeb.getEventResult(contractAddress, {
//       eventName: "Registration",
//       size: 200,
//       onlyConfirmed: true,
//     });

//     if (response.length == 0) return [];
//     let partners = response.filter((r) => r.result.orignalRefId == userId);

//     let lastResult = response[response.length - 1];
//     while (lastResult.fingerprint) {
//       const nextResponse = await tronWeb.getEventResult(contractAddress, {
//         eventName: "Registration",
//         size: 200,
//         onlyConfirmed: true,
//         fingerprint: lastResult.fingerprint,
//       });
//       if (nextResponse.length == 0) break;

//       lastResult = nextResponse[nextResponse.length - 1];
//       partners.concat(
//         nextResponse.filter((r) => r.result.orignalRefId == userId)
//       );
//     }
//     partners = partners.map((u) => u.result);
//     return partners;
//   }
// };

function getDate(x) {
  const myDate = new Date(x * 1000);
  return myDate;
}
